import { da } from 'date-fns/locale';
import * as React from 'react';

export default function RowAtualizacoes({ row }) {

  const rowArray = Object.entries(row).map(([key, value]) => ({ key, value }));


  return (
    <tr>
      {rowArray.map((item, idx) => {

        let className = '';

        if (typeof item.value === "string" && item.value.includes('/')) {
          // Assume formato DD/MM/YYYY
          const [day, month, year] = item.value.split('/');

          const itemDate = `${year.slice(0, 4)}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;

          const todayStr = new Date().toISOString().slice(0, 10);

          if (itemDate !== todayStr) {
            className = 'text-red';
          }
        }

        return (
          <td key={idx} className={className}>
            {item.value}
          </td>
        );
      })}
    </tr>
  );
}
